import { render, staticRenderFns } from "./codevedor_component.vue?vue&type=template&id=f245bf02&scoped=true"
import script from "./codevedor_component.vue?vue&type=script&lang=js"
export * from "./codevedor_component.vue?vue&type=script&lang=js"
import style0 from "./codevedor_component.vue?vue&type=style&index=0&id=f245bf02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f245bf02",
  null
  
)

export default component.exports